<template>
  <div class="edit-wrapper padding-lr-sm">
    <div class="score-info">
      <div class="flex align-center  score-info-title margin-bottom-sm">
        <h3>{{ info.year }}年 - {{ info.name }}</h3>
        <el-button type="primary" circle icon="el-icon-edit" class="margin-left" size="medium"
                   @click="editScore"></el-button>
      </div>
      <el-collapse v-model="activeName" accordion class="score-info-desc">
        <el-collapse-item title="：" name="1">
          <template slot="title">
            <b>注意事项</b>
          </template>
          <div v-html="info.desc" class="score-info-desc-content"></div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="flex align-center justify-between margin-tb-sm">
      <h3 class="font-size-lg">打分表信息</h3>
      <div class="flex align-center">
        <el-link :href="excelFile" target="_blank" class="margin-right-xs" :underline="false">
          <el-button size="medium" type="warning">下载模版</el-button>
        </el-link>

        <el-upload
          ref="upBtn"
          class="upload-demo"
          :action="actions"
          :name="'file'"
          :data="upData"
          :before-upload="handleBefore"
          :on-success="handleSuccess"
          multiple
          :limit="1"
          :show-file-list="false"
        >
          <el-button size="medium" type="primary">导入打分表</el-button>
        </el-upload>

      </div>
    </div>
    <div class="flex align-start">
      <stageModular :infoId="info.id" :parentId="0" :stageNum="1" :stageTitle="'一级指标'"
                    @chioseTarget="chioseTarget" @delTarget="delTarget"/>
      <stageModular :infoId="info.id" :parentId="firstId" :stageNum="2" :stageTitle="'二级指标'"
                    @chioseTarget="chioseTarget" @delTarget="delTarget"
                    v-if="firstId"/>
      <stageModular :infoId="info.id" :parentId="twoId" :stageNum="3" :stageTitle="'三级指标'"
                    @chioseTarget="chioseTarget" @delTarget="delTarget"
                    v-if="twoId"/>
      <stageModular :infoId="info.id" :parentId="threeId" :stageNum="4" :stageTitle="'四级指标'"
                    @chioseTarget="chioseTarget" @delTarget="delTarget"
                    v-if="threeId"/>
      <stageInfoModular :stageTitle="'细则'" :infoId="info.id" :parentId="fourId" v-if="fourId"/>
    </div>


    <scoreDialog
      :setId="setId"
      :setItem="setItem"
      :scoreDialog="scoreDialog"
      @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import scoreDialog from "@/views/admin/dialog/scoreDialog";
import stageModular from "@/components/stageModular";
import stageInfoModular from "@/components/stageInfoModular";
import {playDetail} from "@/api/admin";
import {excelFile, upFeil} from "@/config";
import {getToken} from "@/utils/index";

export default {
  name: "scoreEdit",
  data() {
    return {
      info: {
        id: '',
        year: '',
        name: '',
        desc: '',
      },
      activeName: '1',
      scoreDialog: false,
      setId: 0,
      setItem: {},

      firstId: 0,
      twoId: 0,
      threeId: 0,
      fourId: 0,

      excelFile:excelFile

    }
  },
  computed: {
    actions() {
      return upFeil + '/admin/import/importScore'
    },
    upData() {
      return {
        id: this.info.id,
        token: getToken().token
      }
    }
  },
  created() {
    this.$emit("setIndex", '/admin/scoreList', "评估打分表编辑", true);
    this.info.id = Number(this.$route.params.id)
    this.getInfo()
  },
  components: {scoreDialog, stageModular, stageInfoModular},
  methods: {
    handleBefore() {
      this.loading = this.$loading({
        lock: true,
        text: '导入中，请等待...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        this.loading.close();
      }, 60000);
    },
    handleSuccess(file) {
      if (file.status === 200) {
        this.loading.close();
        this.$message.success('导入成功')
        window.location.reload()
      } else {
        this.loading.close();
        this.$message.error(file.msg)
      }
      this.$refs['upBtn'].clearFiles()
    },
    //  选择指标
    chioseTarget(val) {
      switch (val[0]) {
        case 1 :
          this.firstId = val[1], this.twoId = '', this.threeId = '', this.fourId = ''
          break
        case 2:
          this.twoId = val[1], this.threeId = '', this.fourId = ''
          break
        case 3:
          this.threeId = val[1], this.fourId = ''
          break
        case 4:
          this.fourId = val[1]
      }
    },
    delTarget(val) {
      // val 代表级别
      switch (val) {
        case 1 :
          this.firstId = '', this.twoId = '', this.threeId = '', this.fourId = ''
          break
        case 2:
          this.twoId = '', this.threeId = '', this.fourId = ''
          break
        case 3:
          this.threeId = '', this.fourId = ''
          break
        case 4:
          this.fourId = ''
      }
    },
    //  员工信息编辑后回调
    cancelDialog() {
      this.setId = 0;
      this.setItem = {};
      this.scoreDialog = false;
      this.getInfo()
    },
    //  修改评估表基本信息
    editScore() {
      this.setItem = this.info;
      this.setId = this.info.id;
      this.scoreDialog = true;
    },
    //  获取评估表基本信息
    async getInfo() {
      const res = await playDetail(this.info.id)
      this.info = {
        id: this.info.id,
        year: res.data.playingData.year,
        name: res.data.playingData.name,
        desc: res.data.playingData.content,
      }
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.edit-wrapper {
  .score-info {
    .score-info-title {
      h3 {
        font-size: 22px;
        color: #368ad1;
        line-height: 150%;
      }
    }

    .score-info-desc {
      b {
        font-size: 18px;
      }

      .score-info-desc-content {
        font-size: 16px;
        line-height: 150%;
      }
    }
  }
}
</style>
